import { render, staticRenderFns } from "./biochemical.vue?vue&type=template&id=e140472a&scoped=true"
import script from "./biochemical.vue?vue&type=script&lang=js"
export * from "./biochemical.vue?vue&type=script&lang=js"
import style0 from "./biochemical.vue?vue&type=style&index=0&id=e140472a&prod&scoped=true&lang=css"
import style1 from "./biochemical.vue?vue&type=style&index=1&id=e140472a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140472a",
  null
  
)

export default component.exports